import styled from "styled-components"
import FadeIn from "react-fade-in"

const ListContainer = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const StyledFade = styled(FadeIn)`
  & > div:nth-of-type(1),
  & > div:nth-of-type(3) {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`
const BorderTaxo = styled.button`
  border: 1px solid ${(props) => props.theme.a_color_gradients.a_dark};
  color: ${(props) =>
    props.activeBool ? props.activeText : props.theme.a_color_gradients.a_dark};
  background-color: ${(props) =>
    props.activeBool ? props.theme.a_color_gradients.a_dark : props.activeText};
  &:hover {
    background-color: ${(props) =>
      props.activeBool ? null : props.theme.a_color_gradients.a_dark};
    color: ${(props) => (props.activeBool ? null : props.activeText)};
  }
  &::after {
    ${(props) =>
      props.activeBool
        ? 'content: " \\D7";margin-left: 5px;line-height: 1;'
        : ""};
  }
`

const ContainerLight = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
  & > div {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`

const ActusPeriodFilter = styled.p`
  color: ${(props) =>
    props.active === true
      ? props.theme.b_color_gradients.b_dark
      : props.theme.a_color_gradients.a_dark};
`

const ActusPeriodFilterContainer = styled.div`
  border-right: 2px solid ${(props) => props.theme.a_color_gradients.a_light};
  @media (max-width: 900px) {
    border-bottom: 2px solid ${(props) => props.theme.a_color_gradients.a_light};
  }
`
const ActusItem = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  &:hover div:first-of-type::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
export {
  ListContainer,
  StyledFade,
  BorderTaxo,
  ContainerLight,
  ActusPeriodFilterContainer,
  ActusPeriodFilter,
  ActusItem,
}
